import { render, staticRenderFns } from "./GlobalNavigationBar.vue?vue&type=template&id=754cd0e6&"
import script from "./GlobalNavigationBar.vue?vue&type=script&lang=js&"
export * from "./GlobalNavigationBar.vue?vue&type=script&lang=js&"
import style0 from "./GlobalNavigationBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VAppBar,VTab,VTabs,VTabsSlider})
